import { useRef } from 'react';
import { createPortal } from 'react-dom';
import { useLockBodyScroll } from '../../hooks/useLockBodyScroll';

interface PortalModalProps {
  isOpen: boolean;
  setIsOpen?: (val: boolean) => void;
  children: React.ReactNode;
}

const PortalModal: React.FC<PortalModalProps> = (props) => {
  const { isOpen, children, setIsOpen } = props;

  const modalRef = useRef<HTMLDivElement>(null);

  useLockBodyScroll(isOpen);

  const handleClickOutside = (e: any) => {
    e.stopPropagation();
    if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
      setIsOpen?.(false);
    }
  };

  if (!isOpen) return <></>;

  return createPortal(
    <div
      className="fixed w-screen h-screen top-0 left-0 flex bg-secondary-grey items-center justify-center z-101 bg-opacity-80"
      onClick={handleClickOutside}
      role="modal-background"
    >
      <div
        className="flex justify-center w-full"
        ref={modalRef}
        role="modal-body"
      >
        {children}
      </div>
    </div>,
    document.body,
  );
};

export default PortalModal;
